export const DB_CONFIG = {
    apiKey: "AIzaSyBQ0xj1YeBbe4w0UT_EMj6TplGDP7dm5n8",
    authDomain: "note-9135a.firebaseapp.com",
    databaseURL: "https://note-9135a.firebaseio.com",
    projectId: "note-9135a",
    storageBucket: "note-9135a.appspot.com",
    messagingSenderId: "176647568820"
  };


// WEBPACK FOOTER //
// ./src/Config/config.js